import React from 'react'
import { random } from '../../../utils'


class AnimationItem extends React.PureComponent {
  
    constructor() {
        super();
        this.num = 0;
        this.state = {
            show: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== ''){
            if (this.props.content.img !== nextProps.content.img){
                this.setState({
                    show: true
                }, () => {
                    document.querySelector('.animation__item').addEventListener('webkitAnimationEnd', () => {
                        this.num = this.num + 1;
                        if (this.num === 2){
                            this.num = 0;
                            this.setState({
                                show: false
                            })
                        }
                    })
                })
            }
        }
    }

    getRandomText () {
        const texts = ['5秒前拼课成功', '正在拼课', '1秒前发起了拼课', '3秒前给了五星好评']
        return texts[random(0, 4)]
    }

    getTimelineRandomText () {
        const texts = ['5秒前购买成功', '正在购买', '3秒前给了五星好评']
        return texts[random(0, 3)]
    }

    render() {
        if (!this.state.show){
            return null
        }

        return (
            <div className="animation__item">
                <div className="item__icon" style={{backgroundImage: `url(${this.props.content.img})`}}>

                </div>
                {
                    this.props.type === 'group' && (
                        <div className="item__text">
                            {this.props.content.name}{this.getRandomText()}
                        </div>
                    )
                }
                {
                    this.props.type === 'timeline' && (
                        <div className="item__text">
                            {this.props.content.name}{this.getTimelineRandomText()}
                        </div>
                    )
                }
                {
                    !this.props.type && (
                        <div className="item__text">
                            {this.props.content.time}秒前<br/>买了课程
                        </div>
                    )
                }
            </div>
        )
    }
}

export default AnimationItem


// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/AnimationItem.js